import { render, staticRenderFns } from "./ZipIcon.vue?vue&type=template&id=57ad94e8&"
import script from "./ZipIcon.vue?vue&type=script&lang=js&"
export * from "./ZipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports